export default function DocumentIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 6.36364V0H7V2.54545H2.8V6.36364H0ZM25.2 6.36364V2.54545H21V0H28V6.36364H25.2ZM0 28V21.6364H2.8V25.4545H7V28H0ZM21 28V25.4545H25.2V21.6364H28V28H21ZM4.2 24.1818V3.81818H23.8V24.1818H4.2ZM9.8 11.4545H18.2V8.90909H9.8V11.4545ZM9.8 15.2727H18.2V12.7273H9.8V15.2727ZM9.8 19.0909H18.2V16.5455H9.8V19.0909Z"
        fill="#4C0F28"
      />
    </svg>
  );
}
